.hero {
  position: absolute;
  position-anchor: --thread;
  position-area: center center;
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-md);
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.agent {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-md);
  width: 40cqw;
  max-width: 30rem;
  mix-blend-mode: screen;
  .spinner {
    position: relative;
    width: 100%;
    margin-bottom: calc(var(--mantine-spacing-md) * -3);
    object-fit: contain;
  }
}
